import React from 'react';
import { connect } from 'react-redux';
import { navigate } from 'gatsby';
import { compose } from 'redux';

import Indicator from '../../components/indicator';
import { REDIRECT_PARAM } from '../../constants';

/**
 * Private route component
 * Restricts access to components
 * If unauthenticated the user is redirected to login
 */

const PrivateRoute = ({
  as: Component,
  authenticated,
  authLoaded,
  ...props
}) => {
  if (!authLoaded) {
    return <Indicator spin />;
  }
  if (authenticated) {
    return <Component {...props} />;
  }
  const urlParms = new URLSearchParams(props.location.search);
  urlParms.set(REDIRECT_PARAM, props.location.pathname);
  navigate(`/login/?${urlParms.toString()}`);
  return null;
};

export default compose(
  connect(({ auth: { authenticated, authLoaded } }) => ({
    authenticated,
    authLoaded
  }))
)(PrivateRoute);
